import {
  Header,
  HeaderContent,
  HeaderLinkZone,
  HeaderRightZone,
  HeaderSearch,
  Headers,
} from "design-react-kit";
import React from "react";

import PropTypes from "prop-types";
import { useTranslate } from "react-admin";
import logo from "../assets/logo.png";
import Link from "./Link";

const SlimHeader = () => {
  return (
    <Header type="slim" theme={"dark"}>
      <HeaderContent className="it-header-socials-zone-wrapper">
        <HeaderLinkZone
          children={
            <Link
              className="children-underline"
              href="https://regione.campania.it/"
              children={"Portale Istituzionale"}
              style={{
                color: "white",
                marginLeft: "10px",
              }}
            />
          }
        />
      </HeaderContent>
    </Header>
  );
};

const CenterHeader = () => {
  const translate = useTranslate();
  return (
    <header role="banner" aria-label="Intestazione del sito">
      <Header type="center" theme="light">
        <HeaderContent>
          <div className="it-header-center-content-wrapper">
            <div className="it-brand-wrapper">
              <Link href="/" style={{ color: "black" }}>
                <img id="logo" src={logo} alt={translate("website.name")} />
                <div className="it-brand-text">
                  <h1
                    style={{
                      fontSize: "1.778em",
                      marginBottom: 0,
                      fontWeight: 600,
                    }}
                  >
                    {translate("website.owner")}
                  </h1>
                  <h2
                    style={{
                      fontSize: "0.889em",
                      marginBottom: 0,
                      fontWeight: "normal",
                    }}
                  >
                    {translate("website.name")}
                  </h2>
                </div>
              </Link>
            </div>
          </div>
          <HeaderRightZone>
            <HeaderSearch
              label={translate("website.search")}
              href="/search"
              iconName="it-search"
            />
          </HeaderRightZone>
        </HeaderContent>
      </Header>
    </header>
  );
};

const CompleteHeader = ({ sticky }) => {
  return (
    <Headers sticky={!!sticky}>
      <SlimHeader />
      <CenterHeader />
    </Headers>
  );
};

CompleteHeader.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  type: PropTypes.string,
};

CompleteHeader.defaultProps = {
  type: "default",
};

export default CompleteHeader;
